import { Entity, EntityMetadata } from '@msdk/definitions'
import { distinct, i18n } from '@msdk/forms'

export function getRoleLabel(e: Entity, tFunc: (idml: string, description: string) => string) {
  if (e.fields['GRP.IDML']) {
    return `${tFunc(e.fields['GRP.IDML']?.value, e.fields['GRP.DESCRIPTION']?.value)} - ${tFunc(
      e.fields['IDML']?.value,
      e.fields['DESCRIPTION']?.value,
    )}`
  } else {
    return tFunc(e.fields['IDML']?.value, e.fields['DESCRIPTION']?.value)
  }
}

export async function loadInvolvedMSForRoles(roles: Entity[], i18nContext: i18n) {
  const msToLoad: string[] = []
  ;(roles || []).forEach((role: Entity) => {
    const toLoad = role.fields['OWNER_MS']?.value
    msToLoad.push(toLoad)
  })

  const filtered = msToLoad.filter(distinct)

  const loadPromises: Promise<void>[] = []
  filtered.forEach((ms) => {
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const entityBaseMetadata: EntityMetadata = { msProvider: ms, name: ms } as any
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    const moduleBaseMetadata: EntityMetadata = { msProvider: ms, name: ms } as any
    const promise = i18nContext.load(moduleBaseMetadata, entityBaseMetadata, '')
    loadPromises.push(promise)
  })

  await Promise.all(loadPromises)
}
